// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'axios'

export const getData = createAsyncThunk('tariffs/getData', async params => {
  const response = await axios.post('https://api.fntpf.ir/get/adminTariff', params)
  return response.data
})

export const addTariff = createAsyncThunk(
  'tariffs/addTariff',
  async (params, { dispatch, getState }) => {
    await axios.post('https://api.fntpf.ir/add/adminTariff', params)
    await dispatch(getData(getState().permissions.params))
    return response.data
  }
)

export const updateTariff = createAsyncThunk(
  'tariffs/updateTariff',
  async (params) => {
    await axios.post('https://api.fntpf.ir/add/adminTariff', params)
    // await dispatch(getData(getState().permissions.params))
    return response.data
  }
)

export const deletePermission = createAsyncThunk('tariffs/deletePermission', async (id, { dispatch, getState }) => {
  console.log('ID: ', id)
  await axios.post('https://api.fntpf.ir/delete/Tariff', id)
  await dispatch(getData(getState().permissions.params))
  return response.data
})

export const permissionsSlice = createSlice({
  name: 'tariffs',
  initialState: {
    data: [],
    total: 1,
    params: {},
    allData: [],
    selected: null,
    status: null
  },
  reducers: {
    selectPermission: (state, action) => {
      if (action.payload === null) {
        state.selected = null
      } else {
        state.selected = action.payload
      }
    }
  },
  extraReducers: builder => {
    builder.addCase(getData.fulfilled, (state, action) => {
      state.data = action.payload.data
      state.total = action.payload.allData.length
      state.params = action.payload.params
      state.allData = action.payload.allData
    }).addCase(addTariff.fulfilled, (state, action) => {
      state.status = action.payload
    }).addCase(updateTariff.fulfilled, (state, action) => {
      state.status = action.payload
    })
  }
})

export const { selectPermission } = permissionsSlice.actions

export default permissionsSlice.reducer
